import createReducer from "./createReducer";
import { CREATIVE_VERSIONS_ACTIONS } from './actions/CreativeVersions';
import { LIBRARY_ACTIONS } from './LibraryProperties';

import { ASSET_ACTIONS } from './actions/Assets';
import { CREATIVES_ACTIONS } from './actions/Creatives';
import { CONCEPTS_ACTIONS } from './actions/Concepts';

export const SELECT_ACTIONS = {
	TOGGLE_ITEM:"TOGGLE_ITEM",
	TOGGLE_ITEMS:"TOGGLE_ITEMS",
	CLEAR_SELECTION:"CLEAR_SELECTION",
	RESET_SELECTION:"RESET_SELECTION",

	CLEAR_LEVEL: "CLEAR_LEVEL",
};

export function toggleSelectedItem(id, level, isSelected){
	return (dispatch) => {
		return dispatch({
			type: SELECT_ACTIONS.TOGGLE_ITEMS,
			payload:{
				level,
				isSelected,
				selectedIds: [id],
			},
		});
	};
}

function findIndexes(items, endId, selectedItems, buildItemId){
	const lastSelectedItem = selectedItems.at(-1);

	const [first, last] = items.reduce((ids, item, itemIdx) => {
		const itemId = buildItemId(item);
		if(itemId === endId || itemId === lastSelectedItem) {
			ids.push(itemIdx);
		}
		return ids;
	}, []);

	return [first, last].sort((curr, next) => curr - next);
}

function defaultBuildSelectedList(first, last, items, selectedItems, buildItemId) {
	const bulkSelection = new Set(selectedItems);

	for(let i = first; i <= last; i++) {
		const itemId = buildItemId(items[i]);
		bulkSelection.add(itemId);
	}

	return [...bulkSelection];
}

const defaultSelectItems = (state, level) => state[level].items;
const defaultBuildItemId = item => item.id;


export function shiftSelect(
	endId,
	level,
	{
		selectItems = defaultSelectItems,
		buildItemId = defaultBuildItemId,
		buildSelectedList = defaultBuildSelectedList,
	} = {}){
	return (dispatch, getState) => {
		const state = getState() || {}
			, selectedItems = state.selected[level] || []
			, items = selectItems(state, level);

		if(selectedItems.length <= 0) {
			return dispatch(toggleSelectedItem(endId, level, true));
		}

		const [first, last] = findIndexes(items, endId, selectedItems, buildItemId);
		const selectedIds = buildSelectedList(first, last, items, selectedItems, buildItemId);

		return dispatch({
			type: SELECT_ACTIONS.TOGGLE_ITEMS,
			payload: {
				level,
				isSelected: true,
				selectedIds,
			},
		});
	};
}

export function selectMultiple(ids, level, isSelected) {
	return (dispatch) => {
		return dispatch({
			type: SELECT_ACTIONS.TOGGLE_ITEMS,
			payload: {
				level,
				isSelected,
				selectedIds: ids,
			},
		});
	};
}

export function clearLevel(level){
	return (dispatch) => {
		return dispatch({
			type: SELECT_ACTIONS.CLEAR_LEVEL,
			payload: {
				level,
			},
		});
	};
}

export function clearSelected() {
	return (dispatch) => {
		return dispatch({ type: SELECT_ACTIONS.RESET_SELECTION });
	};
}

const IT = {
	libraries:[],
	creatives:[],
	creativePreviews: [],
	versions:[],
	assets:[],
	existingCreatives:[],
	qa:[],
};

const HANDLERS = {
	[SELECT_ACTIONS.TOGGLE_ITEMS]:addMultiple,
	[SELECT_ACTIONS.CLEAR_SELECTION]:clearURL,
	[SELECT_ACTIONS.RESET_SELECTION]:clearAll,

	[SELECT_ACTIONS.CLEAR_LEVEL]: removeLevelItems,

	// Other actions can also clear selections
	[CREATIVE_VERSIONS_ACTIONS.LOAD_CREATIVE_VERSIONS_SUCCESS]: clearCreativeVersions,
	[CREATIVE_VERSIONS_ACTIONS.DELETE_VERSIONS_SUCCESS]: clearCreativeVersions,
	[CREATIVE_VERSIONS_ACTIONS.CREATIVE_VERSIONS_CHANGE_PAGE]: clearCreativeVersions,
	[CREATIVES_ACTIONS.DELETE_CREATIVE_SUCCESS]: clearAll,
	[CREATIVES_ACTIONS.DUPLICATE_CREATIVES_SUCCESS]: clearAll,
	[CONCEPTS_ACTIONS.DELETE_CONCEPT_SUCCESS]: clearAll,
	[ASSET_ACTIONS.RESET_ASSETS_LIST]: clearAll,
	[CREATIVE_VERSIONS_ACTIONS.RESET_CREATIVE_VERSIONS]: clearAll,
	[CREATIVES_ACTIONS.RESET_CREATIVES_LIST]: clearAll,
	[ASSET_ACTIONS.DELETE_ASSET_SUCCESS]: clearAll,
	[ASSET_ACTIONS.DELETE_VERSIONS_SUCCESS]: clearAll,
	[LIBRARY_ACTIONS.LOAD_LIBRARY_AJAX]: clearAll,
	[ASSET_ACTIONS.LOAD_ASSETS_AJAX]: clearAll,

	// Filter actions
	['CREATIVE_SET_COLUMN_FILTER']: clearAll,
	['CREATIVE_UPDATE_COLUMN_FILTER']: clearAll,
	['CREATIVE_REMOVE_COLUMN_FILTER']: clearAll,
	['CREATIVE_CLEAR_COLUMN_FILTERS']: clearAll,
	['ASSETS_SET_COLUMN_FILTER']: clearAll,
	['ASSETS_UPDATE_COLUMN_FILTER']: clearAll,
	['ASSETS_REMOVE_COLUMN_FILTER']: clearAll,
	['ASSETS_CLEAR_COLUMN_FILTERS']: clearAll,
};

export function addMultiple(state, action) {
	const { level, selectedIds, isSelected } = action.payload;
	let selectedSet = new Set(state[level] || []);

	if(isSelected){
		selectedIds.forEach((id) => {
			selectedSet.add(id);
		});
	} else {
		selectedIds.forEach((id) => {
			selectedSet.delete(id);
		});
	}

	return {
		...state,
		[level]: [...selectedSet],
	};
}

export function removeLevelItems(state, action){
	const { level } = action.payload;

	return {
		...state,
		[level]: [],
	};
}

export function clearAll() {
	return { ...IT };
}

function clearCreativeVersions(state) {
	return {
		...state,
		versions: [],
	};
}

function clearURL(){
	return { url:null };
}


export const REDUCERS = {
	// addSelection,
	clearURL,
};

export default createReducer(IT, HANDLERS);
